<template>
  <!-- 展商邀约 -->
  <div class="menu-item-r">
    <div class="bl-container">
      <el-tabs class="select-tabs" v-model="selectValue" @tab-click="handleClick">
        <el-tab-pane :label="$t('common.confirmedText') + '（' +  contactPersonNum + '）'" name="0"></el-tab-pane>
        <el-tab-pane :label="$t('common.toBeConfirmed') + '（' +  inviteRecordNum + '）'" name="1"></el-tab-pane>
      </el-tabs>
      <!-- 分配状态-只有在全部时显示 -->
      <!-- <div class="select-view" v-show="selectValue == '0'">
        <label class="label-style">分配状态</label>
        <el-select v-model="selectSubValue" size="small" :placeholder="$t('please_select')" @change="selectSubStatus($event)">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div> -->
      <div class="text-right" v-if="subjectType == 'ACTOR' && ((contactPersonNum > 0 && selectValue == 0) || (inviteRecordNum > 0 && selectValue == 1))"><el-button type="primary" @click="dataExport" size="small">{{$t('Export')}}</el-button></div>
      <div class="list-view margin-t-12" v-show="dataList && dataList.length != 0">
        <el-row :gutter="30">
          <template v-for="(item, index) in dataList">
            <el-col :span="8" class="card-list-item" :key="item.id">
              <div class="mstyle-card" @click.stop="skipDetails(item)" v-loading="item['loading']">
                <div class="card-top-view">
                  <div class="top-view">
                    <div class="staff-text" v-show="item.currentName">{{ $t('invites.employe') }} : {{item.currentName}}</div>
                    <el-button class="distribute-btn" v-if="subjectType == 'ACTOR' && selectValue == '0'" size="mini" @click.stop="distribute(item, index)">{{$t('invites.assignEmployees')}}</el-button>
                  </div>
                  <div class="user-info-view">
                    <div>
                      <el-avatar class="avatar-img" :size="60" :src="item.headImage" v-if="item.headImage"></el-avatar>
                      <el-avatar class="avatar-img"
                        :size="60"
                        :src="defImage('head')" v-else>
                      </el-avatar>
                    </div>
                    <div class="info-view">
                      <div class="info-details">
                        <span class="name-text">{{item.name}}</span>
                        <span class="post-text">{{item.post}}</span>
                      </div>
                      <div class="commpny-text">{{item.corporateName}}</div>
                      <div>
                        <span class="status-text"
                          v-if="selectValue == 0 && item.intention =='HIGH' ">{{ $t('invites.highMatching') }}</span>
                        <span class="status-text"
                          v-else-if="selectValue == 0 && item.intention =='MIDDLE' ">{{ $t('invites.mediumMatching') }}</span>
                        <span class="status-text"
                          v-else-if="selectValue == 0 && item.intention =='LOW' ">{{ $t('invites.lowMatching') }}</span>
                        <span v-else></span>
                        <span class="status-text" v-if="selectValue != 0 && subjectType == 'ACTOR'">{{ item['subjectType'] === subjectType ?  $t('invites.to') + ' ' + item['name'] + ' ' + $t('invites.confirmed')  :   item['open'] ? $t('invites.toConfirmed2') : $t('invites.to') + ' ' + item['currentName'] + ' ' + $t('invites.confirmed')  }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="tag-list">
                    <template v-if="getQuestionList(item) && getQuestionList(item).length > 0">
                      <template v-for="tag in item.questionList[0]['answerList']">
                        <span class="tag-list-item" :key="tag.aliasName">{{tag.aliasName}}</span>
                      </template>
                    </template>
                  </div>
                </div>
                <div class="card-foot-view">
                  <template v-if="subjectType == 'ACTOR'">
                    <el-button type="text" v-if="item['subjectType'] && item['subjectType'] !== subjectType && item['open']" class="click-button" @click.stop="sure(item, index)"><i class="iconchenggongtishi iconfont btn-icon"></i>{{$t('confirm')}}</el-button>
                  </template>
                  <!-- 展商不能邀约观众 -->
                  <!-- <template v-else-if="subjectType == 'VISITOR'">
                    <el-button type="text" v-if="selectValue == 1 && item['inviteState'] == 'PENDING'" class="click-button" @click.stop="sure(item, index)"><i class="iconchenggongtishi iconfont btn-icon"></i>{{$t('confirm')}}{{selectValue}}</el-button>
                  </template> -->
                  <el-button type="text" class="click-button" @click.stop="msgEventPerson_v(item)"><i class="btn-icon iconxiaoxi_weixuanzhong iconfont"></i>{{$t('invites.message')}}</el-button>
                  <!-- <el-button type="text" class="click-button" @click.stop="skipDetails(item)"><i class="btn-icon iconicon_huabanfuben iconfont"></i>{{$t('invites.details')}}</el-button> -->
                  <el-button type="text" class="click-button" @click.stop="del(item, index)" v-show="selectValue == '0'"><i class="btn-icon iconqingkong- iconfont"></i>{{$t('del')}}</el-button>
                </div>
              </div>
            </el-col>
          </template>
        </el-row>
      </div>
      <el-pagination background layout="prev, pager, next" :total="pagination.total" @current-change="goPage"
        :hide-on-single-page="true" :page-size="pagination.pageSize" :current-page="pagination.currentPage">
      </el-pagination>
      <!-- {{$t('lives.noData')}} -->
      <div v-if="showNoData()" class="text-center"></div>
      <!-- 分配业务员 弹窗 -->
      <winDialog
        :dialogShow.sync="showAssignmentDialog"
        :title="$t('invites.assignEmployees')"
        subTitle=""
        :sure="assignSalesman"
        :cancel="resetEmployeeKeyword"
      >
        <template v-slot:bodyContent>
          <el-form :inline="true" class="employee-search-form">
            <el-form-item>
              <el-input
                v-model="employeeKeyword"
                size="mini"
                class="input__employee-name"
                :placeholder="$t('invites.employeeSearch')"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="openAssignmentDialog">{{ $t('homes.searchPlaceHolder') }}</el-button>
            </el-form-item>
          </el-form>
          <div class="employee-table-wraper">
            <el-table
              :data="employeeList"
              ref="employeeTable"
              stripe
              @current-change="handleCurrentChange"
              :header-cell-style="{ background: '#FAFAFA' }"
              class="employee-table"
            >
              <el-table-column width="35">
                <template slot-scope="scope">
                  <el-radio v-model="assignedEmployeeId" :label="scope.row.id" class="label__employeeId"></el-radio>
                </template>
              </el-table-column>
              <el-table-column prop="userInfoDTO.name" :label="$t('name')" width="180"> </el-table-column>
              <el-table-column prop="userInfoDTO.mobile" :label="$t('phone')" width="180"> </el-table-column>
              <el-table-column prop="userInfoDTO.email" :label="$t('email')"> </el-table-column>
            </el-table>
          </div>
          <div class="current-employee">
            <span class="_select">{{ $t('You selected') }}</span>
            <el-divider direction="vertical"></el-divider>
            <template v-if="currentEmployee.name">
              <span class="_name">{{ currentEmployee.name }} </span>
              <span class="_tel">{{ currentEmployee.mobile || currentEmployee.email }} </span>
            </template>
          </div>
        </template>
      </winDialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { newContactPersonList, inviteRecordList, confirmInviteRecord, exhInviteRecordList, exhContactPersonList, deleteContactPerson, getContactPersonNum, distributionEmployee, exportContactPerson, exportInviteRecord } from '@/api'
import { getEmployeeList } from '@/api/potentialOrder'
import { eventMixin } from '@/mixins/event.js'
import { inviteMixin } from '@/mixins/inviteEvent.js'
import winDialog from '@/components/dialog/dialog'
import { inviteOrIM } from '@/utils/function'
export default {
  components: {
    winDialog
  },
  mixins: [eventMixin, inviteMixin],
  data () {
    return {
      currentUser: {},
      currentIndex: 0,
      contactPersonNum: 0,  // 全部数量
      inviteRecordNum: 0,   // 待确认数量
      showAssignmentDialog: false,
      employeeKeyword: '',
      options: [
        {
          value: '0',
          label: '全部'
        },
        {
          value: '1',
          label: '已分配'
        },
        {
          value: '2',
          label: '未分配'
        }
      ],
      dataList: [],
      isCollect: false,
      selectValue: "0",
      selectSubValue: "0",  // 0: 全部 1: 已分配 2: 未分配
      pagination: {
        pageSize: 6,
        total: 0,
        currentPage: 1
      },
      to: '',
      action: 'chat',
      employeeList: [],
      assignedEmployeeId: '',
      currentEmployee: {
        name: '',
        mobile: ''
      }
    }
  },
  mounted () {
    this.getList();
  },
  computed: {
    ...mapGetters(['language', 'subjectType'])
  },
  methods: {
    dataExport() {
      console.log(this.selectValue)
      let request = null
      if (this.selectValue == 0) {
        request = exportContactPerson()
      } else if (this.selectValue == 1) {
        request = exportInviteRecord()
      }
      request.then(res => {
        return res.data
      }).then(res => {
        if (res.data) {
          window.open(res.data, '_blank')
        }
      })
    },
    getNum() {
      getContactPersonNum().then(res => {
        let data = res.data
        if (data.code == 1000) {
          this.contactPersonNum = data.data.contactPersonNum;
          this.inviteRecordNum = data.data.inviteRecordNum;
        }
      })
    },
    getList () {
      if (this.selectValue == 0) {
        this.getContactPersonList()
      } else {
        this.getInviteRecordList()
      }
      this.getNum();
    },
    //获得全部数据列表
    getContactPersonList () {
      let type = this.subjectType == 'VISITOR' ? 'PERSON_LIST' : 'ACTOR_LIST'
      let data = {
        showType: type,
        contactState: '',
        intention: '',
        applicationId: 1,
        keyword: '',
        timeSort: 'CREATE',
        pageNum: this.pagination.currentPage,
        pageRows: this.pagination.pageSize
      }
      // if (this.selectSubValue == 1) {
      //   // 已分配
      //   data['distributionStatus'] = true;
      // }
      // if (this.selectSubValue == 2) {
      //   // 未分配
      //   data['distributionStatus'] = false;
      // }
      const loading = this.$loading({
        lock: true
      })
      if(this.subjectType == 'VISITOR'){
        newContactPersonList(data)
        .then(res => {
          let data = res.data
          if (data.code == 1000) {
            if (data.data.list) {
              this.dataList = data.data.list;
              this.pagination.pageNum = data.data.pageNum;
              this.pagination.total = data.data.total;
              return;
            }
            this.dataList = [];
          }
        })
        .finally(() => {
          loading.close();
        })
      }else if (this.subjectType == 'ACTOR') {
        exhContactPersonList(data)
        .then(res => {
          let data = res.data
          if (data.code == 1000) {
            if (data.data.list) {
              this.dataList = data.data.list;
              this.pagination.pageNum = data.data.pageNum;
              this.pagination.total = data.data.total;
              return;
            }
            this.dataList = [];
          }
        })
        .finally(() => {
          loading.close();
        })
      }
      
    },

    getInviteRecordList () {//获得待确认数据列表
      let type = this.subjectType == 'VISITOR' ? 'PERSON_LIST' : 'ACTOR_LIST'
      if(this.subjectType == 'VISITOR') {
        let arg = {
          pageNum: this.pagination.currentPage,
          attendTimes: 'DESC',
          companyScale: 'NO',
          showType: type,
          registeredCapital: '',
          pageRows: this.pagination.pageSize
        }
        const loading = this.$loading({
          lock: true
        })
        inviteRecordList(arg)
          .then(res => {
            let data = res.data
            if (data.code == 1000) {
              this.dataList = data.data.list;
              this.pagination.currentPage = data.data.pageNum;
              this.pagination.total = data.data.total;
            }
          })
          .finally(() => {
            loading.close();
          })
      } else if (this.subjectType == 'ACTOR') {
        let arg = {
          pageNum: this.pagination.currentPage,
          pageRows: this.pagination.pageSize
        }
        const loading = this.$loading({
          lock: true
        })
        exhInviteRecordList(arg)
          .then(res => {
            let data = res.data
            if (data.code == 1000) {
              this.dataList = data.data.list;
              this.pagination.currentPage = data.data.pageNum;
              this.pagination.total = data.data.total;
            }
          })
          .finally(() => {
            loading.close();
          })
      }
      
    },
    selectSubStatus (event) {
      this.selectSubValue = event;
      this.getList();
    },
    handleClick (tab) {
      this.selectStatus(tab.index);
    },
    //切换select
    selectStatus (event) {
      this.dataList = [];
      this.pagination = {
        pageSize: 6,
        total: 0,
        currentPage: 1
      }
      this.selectValue = event;
      if (this.selectValue == 0) {
        this.getContactPersonList()
      } else {
        this.getInviteRecordList()
      }
      this.getNum();
    },
    //下一页
    goPage (val) {
      this.pagination.currentPage = val
      this.getList();
    },
    msgEventPerson_v (data, index = 1) {
      data.psjName = data.name
      data.headPortrait = data.headImage
      data.psjRank = data.post
      data.psjComName = data.corporateName
      this.msgEventPerson(data, index)
    },
    skipDetails (data) {
      if (this.subjectType == 'VISITOR') {
        this.pageDetail(data, 'actor')
      } else {
        this.pageDetail(data, 'person')
      }
    },
    distribute (item, index) {
      this.currentUser = item;
      this.currentIndex = index;
      this.openAssignmentDialog();
    },
    del (data, index) {
      data['loading'] = true;
      this.$set(this.dataList, index, data);
      deleteContactPerson({
        id: data.id
      }).then(res => {
        return res.data
      }).then(res => {
        if(res.code === 1000) {
          // 删除成功
          this.dataList.splice(index, 1);
          this.getNum();
        }
      })
    },
    openAssignmentDialog () {
      this.assignedEmployeeId = ''
      this.currentEmployee = {
        name: '',
        mobile: ''
      }
      const loading = this.$loading({
        lock: true
      })
      getEmployeeList({
        userName: this.employeeKeyword
      }).then(res => {
        this.employeeList = res.data.data
        this.showAssignmentDialog = true
        loading.close()
      })
    },
    handleCurrentChange(val) {
      if (val) {
        this.currentEmployee = val.userInfoDTO
        this.assignedEmployeeId = val.id
      }
    },
    // 确认按钮
    sure(data, index) {
      confirmInviteRecord({
        projectId: data.projectId,
        id: data.id
      }).then(res => {
        return res.data
      }).then(res => {
        if(res.code === 1000) {
          this.dataList.splice(index, 1)
          this.$notify.success(this.$t("common.success"))
          this.getNum();
        }
      })
    },
    /** 分配员工 */
    assignSalesman (cb) {
      distributionEmployee({
        id: this.currentUser.id,
        employeeId: this.assignedEmployeeId
      }).then(res => {
        return res.data
      }).then(res => {
        if(res.code === 1000) {
          // 已重新分配
          var data = this.dataList[this.currentIndex];
          data['currentName'] = this.currentEmployee.name;
          this.$set(this.dataList, this.currentIndex, data);
          cb();
          this.sendMsg();
        }
      })
    },
    sendMsg() {
      inviteOrIM({
        acceptId: this.assignedEmployeeId,
        acceptSubjectType: 'ACTOR',
        url:location.href,
        interateType: this.language === 'en' ? 'DISTRBUTION_EMPLOYEE_EN' : 'DISTRBUTION_EMPLOYEE_CN',
        language: this.language
      })
    },
    resetEmployeeKeyword (cb) {
      this.employeeKeyword = ''
      cb()
    },
    getQuestionList (item) {
      if (item) {
        return item.questionList
      }
      return []
    },
    showNoData() {
      if (!this.dataList) {
        return true;
      }
      if (this.dataList.length <= 0) {
        return true;
      }
      return false;
    }
    
  }
}
</script>
<style lang="stylus" scoped>
    .bl-container
        padding-bottom 15px
        margin 30px auto
        background #fbfbfb

</style>
<style lang="stylus">
.menu-item
  cursor:pointer
  .el-icon-tickets 
    margin 0 9px
.menu-item-right
  position: absolute;
  left: 10px;
  display: block;
  width: 150px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
.select-status
  display flex
  align-items center
  margin 30px 0
  font-weight 400
  color $color-black-85
  font-size 14px
  .select-status-title
    margin-right 10px
.card-list
  margin-top 20px
  .card-list-item
    padding 0 30px
    margin-bottom 25px
    .card-content
      background $color-white
.mstyle-card
  display flex
  flex-direction column
  background $color-white
  transition all .3s
  box-shadow 0px 2px 6px 0px $color-black-01

  &:hover {
    box-shadow 0px 2px 5px 0px $box-shadow2
    box-shadow 0 6px 20px 5px $box-shadow1, 0 16px 24px 2px $box-shadow2
  }
  .card-item-top
    padding 12px
    display flex
    flex-direction row
    justify-content space-between
    .now-status
      color $color-blue-50
      font-size 12px
      line-height 16px
  .card-item-content
    display flex
    flex-direction column
    padding 0 12px
    .person-info
      display flex
      flex-direction row
      font-size 14px
      color $color-black-45
      .person-info-details
        margin-left 16px
        margin-top: 5px;
        .info-details{
          line-height 20px
        }
        .details-name
          font-size 16px
          font-weight 500
          color $color-black-65
          margin-right 8px
        .details-commpny{
          margin-top: 8px;
        }
    .tag-list
      display flex
      flex-direction row
      margin 20px 0px 9px 0px
      flex-wrap wrap
      height 68px
      overflow hidden
      .tag-list-item
        flex 0 0 13%
        font-size 12px
        color $color-main
        border-radius 11px
        border 1px solid $color-light9
        margin-right 12px
        padding 3px 9px
        margin-bottom 15px
        background $color-light9
    .user-avatar
      border-radius 100%
  .card-item-foot
    display flex
    flex-direction row
    padding 13px 12px
    background $color-gray-f5
    justify-content space-between
    align-items center
    color $color-black-65
    font-size 14px
    position relative
    .matched-degree
      color $color-blue-50
      font-size 12px
    .foot-menu
      display flex
      flex 1
      flex-direction row
      align-items center
      justify-content flex-end

      .menu-item + .menu-item{
        margin-left: 8px;
      }

      [class^=el-icon-],
      .iconfont
        color $color-main

.select-tabs
  margin-top 15px
  font-size 16px;
  font-family PingFangSC-Regular, PingFang SC;
  font-weight 400;

.select-view
  margin-top 9px;
  .label-style
    line-height 32px;
    font-size 14px;
    font-family PingFangSC-Regular, PingFang SC;
    font-weight 400;
    color $color-black-85;
    margin-right 12px;

.list-view
  background-color $color-gray-fb;
  .card-list-item
    padding 0 30px
    margin-bottom 25px
    .card-content
      background $color-white

.card-top-view
  background-color $color-white
  height 208px;
  padding 15px;
  .top-view
    display flex;
    height 20px;
    .staff-text
      font-size 14px;
      font-family PingFangSC-Regular, PingFang SC;
      font-weight 400;
      color $color-black-65;
      flex 1;
    .distribute-btn
      line-height 0px;
      height 24px;
      font-size 10px;
      font-family PingFangSC-Regular, PingFang SC;
      font-weight 400;

  .user-info-view
    display flex;
    margin-top 18px;
    .avatar-img
      border-radius 50%;
      width 60px;
      height 60px;
    .info-view
      flex 1;
      margin-left 16px;
      .name-text
        font-size 16px;
        font-family PingFangSC-Medium, PingFang SC;
        font-weight 500;
        color $color-black-65;
      .post-text
        margin-left 8px;
        font-size 14px;
        font-family PingFangSC-Regular, PingFang SC;
        font-weight 400;
        color $color-black-45;
      .commpny-text
        font-size 14px;
        font-family PingFangSC-Regular, PingFang SC;
        font-weight 400;
        color $color-black-45;
      .status-text
        margin-right 8px;
        margin-top 8px;
        font-size 12px;
        font-family PingFangSC-Regular, PingFang SC;
        font-weight 400;
        color $color-blue-50;
      .contact-status
        font-size 12px;
        font-family PingFangSC-Regular, PingFang SC;
        font-weight 400;
        color #FFFFFF;
        height 17px;
        line-height 17px;
        padding 0px 8px;
        background $color-blue-48;
        border-radius 2px;
      .un-contact-status
        font-size 12px;
        font-family PingFangSC-Regular, PingFang SC;
        font-weight 400;
        color #FFFFFF;
        height 17px;
        line-height 17px;
        padding 0px 8px;
        background $color-red-78;
        border-radius 2px;
  .tag-list
    display flex
    flex-direction row
    margin 16px 0px 9px 0px
    flex-wrap wrap
    height 68px
    overflow hidden
    .tag-list-item
      text-align center;
      display inline-table;
      flex 0 0 13%
      font-size 12px
      color $color-main
      border-radius 11px
      border 1px solid $color-light9
      margin-right 12px
      padding 3px 9px
      margin-bottom 12px
      background $color-light9

.card-foot-view
  background-color $color-gray-f5
  height 44px;
  text-align right;
  padding 12px;
  .btn-icon
    color: $color-main;
  .click-button
    vertical-align text-top;
    padding 0px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: $color-black-65;

</style>
